import { colorConstants } from 'src/theme/mindly_constants';
import { IonSkeletonText, IonText } from '@ionic/react';
import styled from 'styled-components';
import { Container } from '@mindly/ui-components';

export const SpecialistProfileIonText = styled(IonText)`
  h2 {
    font-family: 'Lato Bold', sans-serif !important;
    color: ${colorConstants.primaryTextColor};
  }

  h3 {
    font-family: 'Lato Regular', sans-serif !important;
    color: ${colorConstants.secondaryTextColor};
  }

  h4 {
    font-family: 'Lato Regular', sans-serif !important;
    color: ${colorConstants.secondaryTextColor};
    margin-bottom: 16px;
  }

  b {
    font-family: 'Lato Bold', sans-serif !important;
    color: ${colorConstants.primaryTextColor};
  }

  h4 b {
    font-family: 'Lato SemiBold', sans-serif !important;
    color: ${colorConstants.primaryTextColor};
  }

  h4 div {
    margin-bottom: 4px;
  }
`;

export const StyledContainer = styled(Container)`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 60px;

  &:first-child {
    margin-top: -20px;
  }

  .gap-16px {
    margin-bottom: -8px;
  }

  .gap-0px {
    margin-bottom: 0px;
  }

  .padding {
    padding-left: 16px;
    padding-right: 16px;
  }

  .white-spaces {
    white-space: pre-wrap;
  }
`;

export const StyledSpecialistProfileSkeleton = styled(IonSkeletonText)`
  border-radius: 6px;
`;

export const StyledProfileFooterFlexContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex !important;

  padding-top: 12px;
  padding-bottom: 10px;

  gap: 10px;
`;

export const WriteButton = styled.button`
  background: #d6f2f9;
  border-radius: 10px;
  color: #177590;
  outline: none;
  padding: 16px;
  position: relative;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  width: 50%;

  ion-icon {
    top: 12px;
    bottom: 12px;
    left: 16px;
    position: absolute;
    width: 24px;
    height: 24px;
  }
`;

export const ScheduleButton = styled.button`
  position: relative;

  outline: none;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  padding: 16px;
  width: 50%;
  background: #177590;
  border-radius: 10px;
  color: #ffffff;

  .appointment-button {
    p {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
    }

    ion-icon {
      top: 12px;
      bottom: 12px;
      left: 16px;
      position: absolute;
      width: 24px;
      height: 24px;
    }
  }
`;

export const SpecialistInfoDivider = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    padding: 24px 0;
    border-bottom: 1px solid #eeeeee;
  }

  & > div:first-child {
    padding-top: 0;
  }

  & > div:last-child {
    border: none;
    padding-bottom: 8px;
  }

  .specialist-match {
    padding: 24px 16px;
  }

  .specialist-stats {
    padding: 24px 16px;
  }
`;

export const BigScheduleButton = styled.button`
  outline: none;
  border: none;
  background: #177590;
  border-radius: 10px;
  padding: 14px;
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: #ffffff;
`;

export const HeaderButton = styled.button`
  outline: none;
  background: transparent;
  color: #000000;
  padding: 0;
  font-size: 24px;
  display: flex;
  border: none;
  align-items: center;

  .favourite-button {
    margin-right: -2px;
  }

  .active {
    color: #c13e18;
  }
`;
